/* DAVINCI 2026: set flavour picker (see snippets/dv-set-flavours.liquid). No dependencies.
   One row per flavour x Nikotinstärke (data-mg). The Nikotinstärke variant buttons act as tabs (only rows of the
   selected strength are shown); quantities are kept per row, so selections persist across tabs and strengths can
   be mixed. The counter counts all rows. Sold-out rows (data-soldout="true") cannot be increased. */
(() => {
  if (window.__dvSet) return; window.__dvSet = true;
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const digits = s => ((String(s || '').match(/\d+/) || [''])[0]);
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const X_ICON = '<svg viewBox="0 0 12 12" width="10" height="10" aria-hidden="true" focusable="false"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/></svg>';

  /* pure helpers (also used by the node test) */
  const core = {
    // picks: [{name, mg, q}] -> sorted by strength, then name
    sortPicks: picks => picks.filter(p => p.q > 0).sort((a, b) => (+a.mg - +b.mg) || a.name.localeCompare(b.name, 'de')),
    // "0 mg ×10, 12 mg ×5"
    mgSummary: picks => { const m = new Map(); core.sortPicks(picks).forEach(p => m.set(p.mg, (m.get(p.mg) || 0) + p.q)); return [...m].map(([mg, q]) => `${mg} mg ×${q}`).join(', '); },
    lineValue: p => `${p.name} ${p.mg} mg ×${p.q}`,
    // strength with most items; tie -> current tab if tied, else lowest strength
    dominantMg: (picks, current) => {
      const m = new Map(); picks.forEach(p => { if (p.q > 0) m.set(p.mg, (m.get(p.mg) || 0) + p.q); });
      if (!m.size) return current; const max = Math.max(...m.values());
      const top = [...m].filter(([, q]) => q === max).map(([mg]) => mg).sort((a, b) => +a - +b);
      return top.includes(current) ? current : top[0];
    },
    canAdd: (total, need, soldout) => !soldout && total < need
  };
  window.__dvSetCore = core;

  function init(box) {
    if (box.dataset.dvInit) return; box.dataset.dvInit = '1';
    const need = parseInt(box.dataset.need, 10) || 5;
    const form = document.getElementById(box.dataset.form);
    const rows = $$('[data-dv-sp-row]', box), props = $$('[data-dv-sp-prop]', box), msg = $('[data-dv-sp-msg]', box);
    const mgProp = $('[data-dv-sp-mgprop]', box);
    const variants = JSON.parse($('[data-dv-sp-variants]', box).textContent || '{}');
    const options = JSON.parse($('[data-dv-sp-options]', box).textContent || '[]');
    const mgIndex = Math.max(0, options.findIndex(o => /nikotin|stärke|mg/i.test(o)));
    const qty = new Map(rows.map(r => [r, 0]));
    const soldout = r => r.dataset.soldout === 'true';
    let mg = null;
    const vis = () => rows.filter(r => r.dataset.mg === mg);
    const count = () => rows.reduce((n, r) => n + qty.get(r), 0);
    const picks = () => rows.filter(r => qty.get(r) > 0).map(r => ({ name: r.dataset.name, mg: r.dataset.mg, q: qty.get(r), row: r }));
    const idInput = () => form && form.querySelector('[name=id]');
    const currentMg = () => { const id = idInput(); const v = id && variants[id.value]; return v ? digits(v[mgIndex]) : digits((Object.values(variants)[0] || [])[mgIndex]); };
    const chips = $('[data-dv-sp-chips]', box), sel = $('[data-dv-sp-sel]', box), mgSum = $('[data-dv-sp-mgsum]', box);

    // per-strength count badges on the Nikotinstärke variant buttons (tabs)
    function mgLabels() {
      const name = options[mgIndex]; if (!name || !form) return [];
      return $$('input[type=radio]', document).filter(i => i.name === name && (i.getAttribute('form') === form.id || form.contains(i)))
        .map(i => [digits(i.value), i.id && document.querySelector(`label[for="${CSS.escape(i.id)}"]`)]).filter(x => x[1]);
    }
    function badges() {
      const per = new Map(); picks().forEach(p => per.set(p.mg, (per.get(p.mg) || 0) + p.q));
      mgLabels().forEach(([m, l]) => {
        let b = l.querySelector('.dv-mgbadge'); const n = per.get(m) || 0;
        if (!n) { if (b) b.remove(); return; }
        if (!b) { b = document.createElement('span'); b.className = 'dv-mgbadge'; b.setAttribute('aria-hidden', 'true'); l.appendChild(b); }
        b.textContent = n;
      });
    }

    let render = function () {
      const n = count();
      rows.forEach(r => {
        const q = qty.get(r); r.dataset.on = q > 0;
        $('[data-dv-sp-qty]', r).textContent = q;
        $('[data-dv-sp-q="-1"]', r).disabled = q === 0;
        $('[data-dv-sp-q="1"]', r).disabled = !core.canAdd(n, need, soldout(r));
      });
      $('[data-dv-sp-n]', box).textContent = n; $('[data-dv-sp-bar]', box).style.width = (100 * n / need) + '%'; box.dataset.full = n === need;
      const anyAvail = vis().some(r => !soldout(r));
      $('[data-dv-sp-empty]', box).hidden = anyAvail;
      // properties: Nikotinstärken + Sorte 1..k ("Peach Cola 0 mg ×10"), sorted by strength then name
      const list = core.sortPicks(picks());
      props.forEach((p, i) => { p.value = list[i] ? core.lineValue(list[i]) : ''; p.disabled = n !== need || !list[i]; });
      if (mgProp) { mgProp.value = core.mgSummary(list); mgProp.disabled = n !== need; }
      // summary chips
      if (chips) {
        chips.innerHTML = list.map((p, i) => `<li class="dv-setpick__chip"><span class="dv-setpick__chipn">${esc(p.name)}</span> <span class="dv-setpick__chipmg">${esc(p.mg)} mg</span> <span class="dv-setpick__chipq">×${p.q}</span> <button type="button" class="dv-setpick__chipx" data-dv-sp-rm="${i}" aria-label="${esc(p.name)} ${esc(p.mg)} mg entfernen">${X_ICON}</button></li>`).join('');
        chips._rows = list.map(p => p.row);
        sel.hidden = !list.length; if (mgSum) mgSum.textContent = list.length ? '(' + core.mgSummary(list) + ')' : '';
      }
      if (n === need) { msg.textContent = 'Alle Sorten gewählt.'; msg.dataset.tone = 'ok'; }
      else if (!anyAvail && n < need) { msg.textContent = 'In dieser Nikotinstärke ist gerade keine Sorte lieferbar. Bitte wähle eine andere Stärke.'; msg.dataset.tone = 'err'; }
      else { const k = need - n; msg.textContent = `Noch ${k} ${k === 1 ? 'Sorte' : 'Sorten'} wählen.`; msg.dataset.tone = 'err'; }
      $$('.single-add-to-cart-button').forEach(b => b.classList.toggle('dv-set-incomplete', n !== need));
      badges();
    };
    function syncMg() {
      const next = currentMg(); if (next === mg) return;
      mg = next;
      rows.forEach(r => { r.hidden = r.dataset.mg !== mg; });
      render();
    }
    box.addEventListener('click', e => {
      const rm = e.target.closest('[data-dv-sp-rm]');
      if (rm) { const r = chips._rows && chips._rows[+rm.dataset.dvSpRm]; if (r) { const i = +rm.dataset.dvSpRm; qty.set(r, 0); render(); const nx = chips.querySelectorAll('[data-dv-sp-rm]'); (nx[Math.min(i, nx.length - 1)] || msg).focus({ preventScroll: true }); } return; }
      const b = e.target.closest('[data-dv-sp-q]'); if (!b || b.disabled) return;
      const r = b.closest('[data-dv-sp-row]'), d = parseInt(b.dataset.dvSpQ, 10);
      if (d > 0 && !core.canAdd(count(), need, soldout(r))) return;
      qty.set(r, Math.max(0, qty.get(r) + d)); render();
    });
    document.addEventListener('change', () => setTimeout(syncMg, 60));
    document.addEventListener('click', e => { if (e.target.closest('variant-selects, .variant-picker, [data-option]')) setTimeout(syncMg, 120); });
    // block add-to-cart until complete (capture phase runs before Vision's submit handler);
    // when complete, point the bundle variant to the chosen colour + dominant strength (same price for all variants)
    document.addEventListener('submit', e => {
      if (e.target !== form) return;
      if (count() === need) { alignVariant(); return; }
      e.preventDefault(); e.stopImmediatePropagation();
      expand(); updBar();
      box.classList.remove('dv-shake'); void box.offsetWidth; box.classList.add('dv-shake');
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
    function alignVariant() {
      const id = idInput(); const cur = id && variants[id.value]; if (!cur) return;
      const want = core.dominantMg(picks(), mg); if (want === digits(cur[mgIndex])) return;
      const hit = Object.entries(variants).find(([, o]) => digits(o[mgIndex]) === want && o.every((v, i) => i === mgIndex || v === cur[i]));
      if (hit) id.value = hit[0];
    }
    // search filter (large sets): hides rows via class only, does not affect counting
    const search = $('[data-dv-sp-search]', box), nores = $('[data-dv-sp-nores]', box);
    function filter() {
      const t = search ? search.value.trim().toLowerCase() : '';
      let shown = 0;
      vis().forEach(r => { const hit = !t || r.dataset.name.toLowerCase().includes(t); r.classList.toggle('is-filtered', !hit); if (hit) shown++; });
      rows.filter(r => r.dataset.mg !== mg).forEach(r => r.classList.remove('is-filtered'));
      if (nores) nores.hidden = !t || shown > 0;
    }
    if (search) { search.addEventListener('input', filter); search.addEventListener('keydown', e => { if (e.key === 'Enter') e.preventDefault(); }); }
    // collapsed picker (homepage, mobile)
    const openBtn = $('[data-dv-sp-open]', box);
    const expand = () => { box.classList.add('is-open'); if (openBtn) openBtn.setAttribute('aria-expanded', 'true'); };
    if (openBtn) openBtn.addEventListener('click', () => { expand(); updBar(); });
    // sticky bottom bar (mobile, large sets) while the picker is on screen
    const mq = window.matchMedia('(max-width: 749px)');
    let bar = null, inView = false;
    if (need > 6) {
      bar = document.createElement('div'); bar.className = 'dv-spbar'; bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<div class="dv-spbar__info"><span class="dv-spbar__n"><b data-spbar-n>0</b>/' + need + ' gewählt</span><span class="dv-spbar__track"><span data-spbar-fill></span></span></div><span class="dv-spbar__price">' + (box.dataset.price || '') + '</span><button type="button" class="dv-spbar__btn" data-dv-spbar-add tabindex="-1"></button>';
      document.body.appendChild(bar);
      bar.querySelector('[data-dv-spbar-add]').addEventListener('click', () => {
        if (count() === need && form) { const btn = form.querySelector('[type=submit][name=add], [type=submit]'); form.requestSubmit ? form.requestSubmit(btn || undefined) : btn && btn.click(); }
        else { const l = $('[data-dv-sp-list]', box); box.classList.remove('dv-shake'); void box.offsetWidth; box.classList.add('dv-shake'); (l || box).scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
      if ('IntersectionObserver' in window) new IntersectionObserver(es => { inView = es[0].isIntersecting; updBar(); }, { threshold: 0.15 }).observe(box);
      mq.addEventListener ? mq.addEventListener('change', updBar) : mq.addListener(updBar);
    }
    function updBar() {
      if (!bar) return;
      const n = count(), on = mq.matches && inView && (!openBtn || box.classList.contains('is-open'));
      bar.classList.toggle('is-on', on); document.body.classList.toggle('dv-spbar-on', on);
      bar.querySelector('[data-spbar-n]').textContent = n;
      bar.querySelector('[data-spbar-fill]').style.width = (100 * n / need) + '%';
      const b = bar.querySelector('[data-dv-spbar-add]'), k = need - n;
      b.textContent = n === need ? 'In den Warenkorb' : `Noch ${k} ${k === 1 ? 'Sorte' : 'Sorten'}`;
      b.classList.toggle('is-ready', n === need); bar.dataset.full = n === need;
    }
    const baseRender = render;
    render = function () { baseRender(); filter(); updBar(); };
    syncMg(); render();
  }
  // quick view / other forms of a set product without a picker: send to the product page
  document.addEventListener('submit', e => {
    const f = e.target; if (!f || !f.id) return;
    const g = document.querySelector(`[data-dv-set-guard][data-form="${f.id}"]`);
    if (!g || document.querySelector(`[data-dv-setpick][data-form="${f.id}"]`)) return;
    e.preventDefault(); e.stopImmediatePropagation(); window.location.href = g.dataset.url;
  }, true);
  const run = () => $$('[data-dv-setpick]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
  document.addEventListener('shopify:section:load', run);
})();
